import React from 'react';
import { BulkImportTargeting } from '../BulkImportTargeting';
import { BulkActionsState } from '../../../models/bulk-actions';
import { UseFormReturn } from 'react-hook-form';
import { BulkImportLinkSettings } from '../BulkImportLinkSettings';
import { BulkImportScheduling } from '../BulkImportScheduling';

export type BulkImportContentViewProps = {
  //
  activeSection: keyof BulkActionsState;
  formInstance: UseFormReturn;
};

export const BulkImportContentView = (props: BulkImportContentViewProps): JSX.Element => {
  const { activeSection, formInstance } = props;
  switch (activeSection) {
    case 'targeting':
    default:
      return <BulkImportTargeting formInstance={formInstance} />;
    case 'linkSettings':
      return <BulkImportLinkSettings formInstance={formInstance} />;
    case 'scheduling':
      return <BulkImportScheduling formInstance={formInstance} />;
  }
};
